import { createReducer, on } from '@ngrx/store';
import * as ReportActions from './report.actions';

export interface ReportState {
  data: any[];
  totalRecords: number;
  loading: boolean;
  exporting: boolean;
  error: string | null;
}

export const initialState: ReportState = {
  data: [],
  totalRecords: 0,
  loading: false,
  exporting: false,
  error: null,
};

export const reportReducer = createReducer(
  initialState,
  on(ReportActions.loadReportData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ReportActions.loadReportDataSuccess, (state, { data, totalRecords }) => ({
    ...state,
    loading: false,
    data,
    totalRecords,
  })),
  on(ReportActions.loadReportDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(ReportActions.exportReport, (state) => ({
    ...state,
    exporting: true,
    error: null,
  })),
  on(ReportActions.exportReportSuccess, (state) => ({
    ...state,
    exporting: false,
  })),
  on(ReportActions.exportReportFailure, (state, { error }) => ({
    ...state,
    exporting: false,
    error,
  })),
  on(ReportActions.resetReportState, () => initialState)
);
